import styled from 'styled-components'

export const Error = styled.span`
    background: palevioletred;
    color: white;
    padding: 20px;
    border: 1px solid white;
    border-radius: 10px;
`



// WEBPACK FOOTER //
// ./src/components/RenderKatex.styles.js